<template>
	<div>
		<!-- <top></top> -->
		<div class="conmtont">
			<div class="flex align-center justify-between padding-sm bg-white margin-tb">
				<!-- <p class="text-sm text-666">首页 - 技能培训 - 详情</p>
				<p class="flex align-center text-999 text-sm pointer" @click="back()">
					<i class="el-icon-back"></i>
					<span>返回</span>
				</p> -->
				<el-breadcrumb separator-class="el-icon-minus">
				  <el-breadcrumb-item :to="{ path: '/' }"><span class="text-sm text-666">首页</span></el-breadcrumb-item>
				  <el-breadcrumb-item :to="{ path: 'skill' }"><span class="text-sm text-666">技能培训</span></el-breadcrumb-item>
				  <el-breadcrumb-item><span class="text-sm text-666">详情</span></el-breadcrumb-item>
				</el-breadcrumb>
			</div>
			<div class="flex">
				<div class="detail">
					<div class="flex radiu-20 bg-white padding-sm">
						<img class="cover margin-right-sm" :src="imgs" >
						<div class="de-cont flex-direction flex justify-between flex-sub">
							<p class="titlw text-32 text-left">{{title}}</p>
							<div class="flex justify-between align-center">
								<div v-if="price != 0" class="text-price text-24 text-bold text-prices text-left margin-top-sm">{{price}}</div>
								<div v-if="price == 0" class="text-24 text-bold text-prices text-left margin-top-sm">免费</div>
								<div class="flex align-center justify-end btns">
									<div class="colt flex align-center justify-center pointer" @click="chosecoll">
										<i class="el-icon-star-off text-theme"></i>
										<p class="margin-left-xs text-666">{{coll?'已收藏':'收藏'}}</p>
									</div>
									<div v-if="!is_buy" class="callbtns flex align-center justify-center margin-left-xs pointer" @click="buy">
										<img class="call-icon" src="../../assets/img/purchase.png" >
										<p class="text-white margin-left-xs">立即购买</p>
									</div>
									<div v-else class="callbtns flex align-center justify-center margin-left-xs pointer" @click="godetail">
										<p class="text-white margin-left-xs">去学习</p>
									</div>
								</div>
							</div>
						</div>
					</div>
					<div class="info bg-white margin-top radiu-20">
						<p class="flex head-item">
							<span @click="infoindex = 0" :class="infoindex == 0?'text-theme active':''" class="margin-right-lg margin-left-lg pointer">课程介绍</span>
							<span @click="infoindex = 1" :class="infoindex == 1?'text-theme active':''" class="margin-right-lg pointer">课程目录</span>
							<span @click="infoindex = 2" :class="infoindex == 2?'text-theme active':''" class="pointer">注意事项</span>
						</p>
						<div v-if="infoindex == 0" class="padding-lr-lg fu-fs26 text-666 bg-white padding-tb" style="min-height: 878rpx;">
							<div class="text-left" v-html="content"></div>
						</div>
						<div v-if="infoindex == 2" class="padding-lr-lg fu-fs26 text-666 bg-white padding-tb" style="min-height: 878rpx;">
							<div class="text-left" v-html="careful"></div>
						</div>
						
						<div  v-if="infoindex == 1">
							<div v-for="(item,index) in chapter" class="flex align-center padding-lr padding-tb-sm align-center solid-bottom pointer">
								<img  v-if="item.is_free&&!is_buy" class="text-left margin-right-sm lovk" src="https://manage.ciiply.com/web/static/skill/lock.png" mode=""> <!-- is_free 0 false 是 1true 否 -->
								<img v-if="!item.is_free||is_buy" class="text-left margin-right-sm audi" :src="type == 0?'https://manage.ciiply.com/web/static/skill/audition.png':'https://wz89.lzym.top/web/static/skill/pdf.png'" mode="">
								<div class="flex align-center">
									<p v-if="!item.is_free&&!is_buy" class="tip text-white text-center bg-theme text-sm">{{type == 1?'免费':'试听'}}</p>
									<p class="fu-fs28">{{item.chapter_title}}</p>
								</div>
							</div>
						</div>
					</div>
				</div>
				<div class="margin-left" style="width:387px;">
					<div class="flex align-center justify-between margin-bottom-sm">
						<p class="title padding-left-sm ">最新精品课</p>
					</div>
					<div v-for="(item,indx) in skillList" :key="indx">
						<SkillList :data="item" :size="18"></SkillList>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import Bus from '@/store/eventBus.js'
	import Top from '@/components/public/top.vue';
	import SkillList from '@/components/list/skill-list.vue';
	export default {
		components: {
			Top,
			SkillList
		},
		data() {
			return {
				infoindex:0,// 0 课程介绍    1 课程目录    2 注意事项    
				id:0,
				careful:'',
				chapter:[],
				content:'',
				type:'',
				title:'',
				price:'',
				pay_num:0,
				is_buy:'',
				imgs:'',
				coll:0,
				chapterCount:'',
				skillList:[],//最新
			}
		},
		created() {
			//通知听不状态栏 选中的页面
			Bus.$emit('chosename','skill')
			this.id = this.$route.query.id
			this.getdetail()
			this.postOperationGetColumn()
			this.getSkillList()
		},
		methods: {
			back(){
				this.$router.back()
			},
			/**
			 * 获取详情
			 * */
			getdetail(){
				this.ajax('get', '/api/pc/course/getInfo', {
					id:this.id,
				}, res => {
					if(res.status == 200){
						this.chapter = res.data.chapter
						this.content = res.data.content
						this.type = res.data.type
						this.title = res.data.title
						this.price = res.data.price
						this.pay_num = res.data.pay_num
						this.is_buy = res.data.is_buy
						this.imgs = res.data.imgs[0]
						this.coll = res.data.is_coll
						this.chapterCount = res.data.chapterCount
					}
				})
			},
			postOperationGetColumn(){
				this.ajax('get', '/api/agreement/getInfo', {
					type:8,
				}, res => {
					if(res.status == 200){
						this.careful = res.data.content
					} else {
					  this.careful = ''
					}
				})
			},
			//收藏取消收藏
			chosecoll(){
				this.ajax('post', '/api/collection/add', {
					type_id:this.id,
					type:2
				}, res => {
					if(res.status == 200){
						this.coll = !this.coll
						this.getdetail()
					} else {
					  this.careful = ''
					}
				})
				
			},
			getSkillList(){
				this.ajax('get', '/api/course/getList', {
					sort:2,
					page:1,
				}, res => {
					if(res.status == 200){
						this.skillList = res.data.data
					}
				})
			},
			buy(){
				this.$router.push({
					name:'buy',
					query: {
						id:this.id
					}
				})
			},
			godetail(){
				this.$router.push({
					name:'center',
					query: {
						type:'purdetail'
					}
				})
				
				
				setTimeout(()=>{
					Bus.$emit('pudid',this.id)
				},500)
			}
		}
	}
</script>

<style scoped lang="less">
	.text-32{
		font-size: 32px;
	}
	.text-24{
		font-size: 24px;
	}
	.radiu-20{
		border-radius: 20px;
	}
	.cover{
		width: 128px;
		height: 163px;
	}
	.detail{
		width: 782px;
	}
	.title{
		position: relative;
		font-size: 22px;
		&:before{
			position: absolute;
			left: 0;
			top: 50%;
			transform: translateY(-50%);
			width: 6px;
			height: 26px;
			background: #09827B;
			content: '';
			
		}
	}
	.info{
		box-shadow: 2px 3px 29px 1px rgba(201,199,199,0.3000);
		.head-item{
			height: 69px;
			line-height: 69px;
			background: #F7F6F6;
		}
		.lovk{
			width: 24px;
			height: 27px;
		}
		.audi{
			width: 26px;
			height: 26px;
		}
		.tip{
			width: 44px;
			height: 24px;
			line-height: 24px;
			border-radius: 6px;
			background: #0B837C;
			margin-right: 15px;
		}
		.active{
			position: relative;
			&:after{
				content: '';
				width: 27px;
				height: 6px;
				background: #0B837C;
				border-radius: 3px;
				position: absolute;
				left: 50%;
				transform: translateX(-50%);
				bottom: 0;
			}
		}
	}
	
	.colt{
		width: 111px;
		height: 45px;
		background: #FFFFFF;
		border: 1px solid #E6E6E6;
		border-radius: 23px;
	}
	
	.de-cont{
		position: relative;
		.btns{
			position: absolute;
			bottom: 0;
			right: 0;
		}
	}
	
	.callbtns{
		width: 193px;
		height: 45px;
		background: #0B837C;
		border-radius: 23px;
		.call-icon{
			width: 19px;
			height: 19px;
		}
	}
	
</style>



// WEBPACK FOOTER //
// src/view/index/skill-detail.vue